import React from "react";

import Home from "../../../templates/teacher/Home";
import { Context, fetchCountAnswers } from "../../../teacherStore";

export default () => {
  const { state, dispatch } = React.useContext(Context);

  React.useEffect(() => {
    if (!!state.teacher.school_id) {
      dispatch(fetchCountAnswers(state.teacher.school_id));
    }
  }, [dispatch, state.teacher.school_id]);

  return <Home school={state.school} onlyAssessment={state.only_assessment} />;
};
